import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BusinessGroupModel } from 'src/app/ViewModel/BusinessGroupModel';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { RoleFeaturePostModel } from 'src/app/ViewModel/RoleFeaturePostModel';
import { CommonService } from '../Common.service';
import { RestApiService } from '../rest-api.service';

@Injectable({
	providedIn: 'root'
})
export class MapRoleFeatureService {

	private readonly dedAgainstDEGetUrl = 'DEDED/GetDEDAgainstDE';
	private readonly roleFeatureLinkGetUrl = 'RoleFeaturesLink/GetRoleFeatures';
	private readonly roleFeaturePostUrl = 'RoleFeaturesLink/PostRoleFeatures';
	private readonly businessGroupListUrl = 'Organization/GetOrganizationAgainstProject';
	private readonly getCommonDedAgainstdeUrl = 'DEDED/GetCommonDEDAgainstDE'

	constructor(
		private commonService: CommonService,
		private restAPIService: RestApiService,
	) { }

	/**
	 * Get Roles,Features List
	 * @param dedDescription Element Description
	 * @param groupId 
	 * @param moduleId 
	 * @param dependentDEId dependentElementId
	 * @param dependentDEDId dependentElementDetailId 
	 */
	//  'Role' | 'Feature'
	getDedAgainstDe(dedDescription: string, groupId: any, moduleId?: any, dependentDEId?: null | number, dependentDEDId: null | number = 0, ProjectId?: number | null): Observable<RoleFeatureModel[]> {
		let reqData = {
			"projectId": !!ProjectId ? ProjectId : this.commonService.getProjectId(),
			"DEDescription": dedDescription,
			"groupId": groupId ? groupId.toString() : null,
			"moduleId": moduleId ? moduleId.toString() : null,
			dependentDEId,
			dependentDEDId,
		};
		return this.restAPIService.new_POST(this.dedAgainstDEGetUrl, reqData);
	}

	getCommonDedAgainstDe(deId: null | number, deDescription?: string) {
		return this.restAPIService.new_POST(this.getCommonDedAgainstdeUrl, { deId, deDescription });
	}

	/**
	 * Fetch previously mapped data from DB
	 * @param groupId 
	 */
	getRoleFeatureLinkData(groupId: number) {
		return this.restAPIService.new_POST(this.roleFeatureLinkGetUrl, { 'projectId': this.commonService.getProjectId(), groupId });
	}

	/**
	 * Save mapped changes
	 * @param reqData
	 */
	postRoleFeature(reqData: RoleFeaturePostModel) {
		return this.restAPIService.new_POST(this.roleFeaturePostUrl, reqData);
	}

	/**
	 * Get business group list
	 * @param projectId 
	 */
	getBusinessGroups(projectId: number): Observable<BusinessGroupModel[]> {
		return this.restAPIService.new_POST(this.businessGroupListUrl, { projectId });
	}
}
